var exports = {
  "_H": "sessionLabelCode__NTZaUO",
  "_0": "detail__9_kE0c",
  "Xr": "promptNavigation__feHgXW",
  "gc": "promptNavigationText__gX08O3",
};

module.exports = exports;
